import React from 'react'
import { graphql } from 'gatsby'
import Helmet from 'react-helmet'

import Layout from '../../layouts/layout'
// import Hero from '../components/hero'

const EarlyCareerPage = ({ data }) => {
  return (
    <Layout>
      <Helmet
        title={'Young Folks/Early Career | ' + data.siteTitle.siteMetadata.title}
        meta={[
          { name: 'description', content: 'IT overriding description but not keywords.' }
        ]}
      />
      <div style={{margin: '90px auto', maxWidth: '92%'}}>
        <h1>Young Folks/Career Start/Early Career (exact name TBD)</h1>
        <p>Welcome to the early-career page.</p>
      </div>
    </Layout>
  )
}

export const query = graphql`
  query {
    siteTitle: site {
      siteMetadata {
        title
      }
    }
  }
`

export default EarlyCareerPage
